'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getLabelColor = exports.getBackgroundColor = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _styles = require('../common/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _colors$baseColors = _styles.colors.baseColors,
    blue = _colors$baseColors.blue,
    lightGreen = _colors$baseColors.lightGreen,
    white = _colors$baseColors.white;
var propTypes = exports.propTypes = {
	backgroundColor: _propTypes2.default.string,
	children: _propTypes2.default.any,
	disabled: _propTypes2.default.bool,
	disabledBackgroundColor: _propTypes2.default.string,
	disabledLabelColor: _propTypes2.default.string,
	fullWidth: _propTypes2.default.bool,
	href: _propTypes2.default.string,
	icon: _propTypes2.default.any,
	label: _propTypes2.default.string,
	labelColor: _propTypes2.default.string,
	labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	labelStyle: _propTypes2.default.object,
	onKeyboardFocus: _propTypes2.default.func,
	onMouseEnter: _propTypes2.default.func,
	onMouseLeave: _propTypes2.default.func,
	onMouseUp: _propTypes2.default.func,
	onClick: _propTypes2.default.func,
	primary: _propTypes2.default.bool,
	secondary: _propTypes2.default.bool,
	style: _propTypes2.default.object
};

var getBackgroundColor = exports.getBackgroundColor = function getBackgroundColor() {
	var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    _ref$primary = _ref.primary,
	    primary = _ref$primary === undefined ? false : _ref$primary,
	    _ref$secondary = _ref.secondary,
	    secondary = _ref$secondary === undefined ? false : _ref$secondary,
	    backgroundColor = _ref.backgroundColor;

	if (primary) {
		return lightGreen;
	} else if (secondary) {
		return blue;
	}

	return backgroundColor;
};

var getLabelColor = exports.getLabelColor = function getLabelColor() {
	var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    _ref2$primary = _ref2.primary,
	    primary = _ref2$primary === undefined ? false : _ref2$primary,
	    _ref2$secondary = _ref2.secondary,
	    secondary = _ref2$secondary === undefined ? false : _ref2$secondary,
	    labelColor = _ref2.labelColor;

	if (primary || secondary) {
		return white;
	}

	return labelColor;
};

var WMRaisedButton = function WMRaisedButton(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_RaisedButton2.default, _extends({}, props, {
			primary: false,
			secondary: false,
			backgroundColor: getBackgroundColor(props),
			labelColor: getLabelColor(props),
			labelStyle: _extends({}, _styles.typography.button, props.labelStyle)
		}))
	);
};

exports.default = WMRaisedButton;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMRaisedButton/index.js